module.exports = __webpack_public_path__ + "static/media/TACP_MENU-normal.cdbb9c45.png";